import { createFileRoute } from '@tanstack/react-router';

import { useTelegramBackButton } from '@common/hooks';
import { Page } from '@common/ui/Page';

import { Interests } from '@widgets/profile/components';

export const Route = createFileRoute('/profile/edit/interests')({
  component: Component,
});

export default function Component() {
  useTelegramBackButton({ to: 'back' });

  return (
    <>
      <Page style={{ padding: 0, paddingTop: 8 }} hasBackground>
        <Interests />
      </Page>
    </>
  );
}
